module.exports = __webpack_public_path__ + "static/media/g-5-b.0d36d6e7.jpg";